/*
*  This directive allows input fields to accept only numbers.
*  We also have the allowPatternDirective that does the same, however it doesn't work with Android devices.
*  This is a backup directive to assist in the meantime.
 */
import { Directive, ElementRef, HostListener, Inject } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
    selector: '[numbers-only]'
})
export class NumbersOnlyDirective {

    constructor(@Inject(NgControl) private control: NgControl,
                @Inject(ElementRef) private $el: ElementRef) {}

    @HostListener('input', ['$event']) onInputChange(event?) {

        const formattedValue = this.$el.nativeElement.value.replace(/[^0-9]/g, '');
        this.control.viewToModelUpdate(formattedValue)
        this.$el.nativeElement.value = formattedValue;

    }
}
